var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"align":"center","cols":"12"}},[_c('organization-chart',{attrs:{"company_id":_vm.company_id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }